import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilePreviewComponent } from './file-preview.component';
import { TimePeriodSelectorComponent } from './time-period-selector/time-period-selector.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        FilePreviewComponent,
        TimePeriodSelectorComponent
    ],
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [
        FilePreviewComponent,
        TimePeriodSelectorComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule {}
